<template>
	<div id="map-waypoint" style="height: 300px"></div>
</template>

<script>
import {MapFeatures} from "@/plugins/mapFeatures";
import Utils from "@/helpers/Utils";
import Api from "@/helpers/api.js";

export default {
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		data: {
			type: Array,
			default: () => [],
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		streetview: {
			type: String,
			required: false,
			default: "false",
		},
		calledFrom: {
			type: String,
			requeride: false,
			default: "maps",
		},
	},
	data() {
		return {
			map: "",
			marker: null,
			markerArray: [],
			mapFeature: null,
		};
	},
	methods: {
		async showPolyline() {
			let routes = [];
			if (this.data.length > 0) {
				this.data.forEach((waypoint) => {
					routes.push({latitude: waypoint.cy, longitude: waypoint.cx});
				});
				await Api.post("/routing/zones", {country: "sur", coordinates: routes}).then((res) => {
					const decodedPath = google.maps.geometry.encoding.decodePath(res.data.routes[0].geometry);
					const lineSymbol = {
						path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
						strokeColor: "#F3F3F3",
						fillColor: "#1A73E8",
						fillOpacity: 1,
						strokeWeight: 5,
					};
					const polyline = new google.maps.Polyline({
						path: decodedPath,
						geodesic: true,
						strokeColor: "#1A73E8",
						strokeOpacity: 1,
						strokeWeight: 5,
						map: this.map,
						icons: [
							{
								icon: lineSymbol,
								offset: "0",
								repeat: "50px",
							},
						],
					});
					return polyline;
				});
			}
		},
		showMarkersInMap() {
			if (this.data.length > 0) {
				this.data.forEach((waypoint, index) => {
					const position = {cy: waypoint.cy, cx: waypoint.cx};
					const markerItem = this.mapFeature.addMarkerToMap(position, {
						icon: Utils.addIconSvgWithLabel("5448ed", index + 1, "white"),
						draggable: false,
						info: {order: index + 1},
						infoWindow: {
							content: this.generateInfowindowContentJob(waypoint, index + 1),
						},
					});
					this.markerArray.push(markerItem);
				});
				setTimeout(() => {
					this.mapFeature.fitBoundsMarkerGroup(this.markerArray);
				}, 600);
			} else {
				this.initialize();
			}
		},
		error(err) {
			this.map.setCenter({lat: 4.686699, lng: -74.0837187});
			console.warn("ERROR(" + err.code + "): " + err.message);
		},
		async initMap() {
			this.map = await new google.maps.Map(document.getElementById("map-waypoint"), {
				center: {lat: 4.686699, lng: -74.0837187},
				zoom: 8,
			});
			this.mapFeature = new MapFeatures(this.map);
			this.showMarkersInMap();
			this.showPolyline();
		},
		generateInfowindowContentJob(infoWindowData, order) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $headerInfoWindowContent = document.createElement("div");
			$headerInfoWindowContent.className = "flex items-center justify-between";
			let $closeButton = document.createElement("button");
			$closeButton.textContent = "X";
			$closeButton.className = "bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
			$closeButton.addEventListener("click", () => {
				this.markerArray.filter((data) => data.info.order === order)[0].infoWindow.close();
			});
			let $title = document.createElement("h5");
			$title.textContent = `${this.$t("Waypoint")} # ${order}`;
			let $position = document.createElement("p");
			$position.innerHTML = `<strong>${this.$t("CurrentPosition")}</strong>: ${
				infoWindowData.cy + ", " + infoWindowData.cx
			} `;
			$position.className = "mt-1 mb-1";
			let $timeService = document.createElement("p");
			$timeService.innerHTML = `<strong>${this.$t("TypeOfService")}</strong>: ${infoWindowData.job_type}`;
			$docFragment.appendChild($position);
			$docFragment.appendChild($timeService);
			$headerInfoWindowContent.appendChild($title);
			$headerInfoWindowContent.appendChild($closeButton);
			$infowindowDivContent.appendChild($headerInfoWindowContent);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
	},
	mounted() {
		this.initMap();
	},
};
</script>

<style scoped>
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	margin-left: -35px;
	margin-right: -35px;
	height: 88vh;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

.customizer-btn-map-opc {
	position: fixed;
	top: 50%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.customizer-btn-map-clear {
	position: fixed;
	top: 45%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 69px;
	left: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-custom-container-calendar {
	height: 560px !important;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}

	.map-top-left-possition {
		position: fixed;
		top: 69px;
		left: 10px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		z-index: 50000;
	}
}
</style>
